import { render, staticRenderFns } from "./ProposalRequestDocuments.vue?vue&type=template&id=05cb53ce&scoped=true"
import script from "./ProposalRequestDocuments.vue?vue&type=script&lang=js"
export * from "./ProposalRequestDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProposalRequestDocuments.vue?vue&type=style&index=0&id=05cb53ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb53ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cb53ce')) {
      api.createRecord('05cb53ce', component.options)
    } else {
      api.reload('05cb53ce', component.options)
    }
    module.hot.accept("./ProposalRequestDocuments.vue?vue&type=template&id=05cb53ce&scoped=true", function () {
      api.rerender('05cb53ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/ProposalRequestDocuments.vue"
export default component.exports